import {
    GET_CIERRE_SEMANAL_DATOS, MODIFY_ARQUEO_CIERRE_SEMANAL, MODIFY_VARIACION_EUROS, MODIFY_VARIACION_TOKENS, MODIFY_MAQ_ARCADE_CIERRE_SEMANAL, RESET_CIERRE_SEMANAL_DATOS, UPDATE_BILLARES_CIERRE_SEMANAL, MODIFY_BANCO_2_CIERRE_SEMANAL,
    DESBLOQUEAR_CIERRE_SEMANAL, CIERRE_SEMANAL_CERRAR_SEMANA, MODIFY_VARIACION_TOKENS_CENTRO
} from "../constants/action_types";

const initialState = { datos: {}, isLoading: false, semanaCerrada: true };

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_CIERRE_SEMANAL_DATOS:

            return {
                datos: {},
                isLoading: true,
                semanaCerrada: true,
                centroid: action.meta.centroid,
                date: action.meta.date
            };

        case GET_CIERRE_SEMANAL_DATOS + "_SUCCESS":

            if(state.centroid !== action.meta.centroid || state.date !== action.meta.date) return state;

            return {
                datos: action.payload.data,
                isLoading: false,
                semanaCerrada: action.payload.data.isSemanaCerrada
            };

        case MODIFY_ARQUEO_CIERRE_SEMANAL:

            const newDatos = { ...state.datos, bancoArcade: action.payload }
            return {
                datos: newDatos,
                isLoading: false,
                semanaCerrada: false
            }

        case MODIFY_BANCO_2_CIERRE_SEMANAL:

            return {
                datos: { ...state.datos, bancoArcade2: action.payload },
                isLoading: false,
                semanaCerrada: false
            }


        case MODIFY_VARIACION_EUROS:

            return {
                datos: {
                    ...state.datos,
                    fondoEurosEnd: action.payload
                },
                isLoading: false,
                semanaCerrada: false
            }

        case MODIFY_VARIACION_TOKENS:

            return {
                datos: {
                    ...state.datos,
                    fondoTokensEnd: action.payload
                },
                isLoading: false,
                semanaCerrada: false
            }

        case MODIFY_VARIACION_TOKENS_CENTRO:


            //calculate new fondoTokensCentroEnd & fondoTokensEnd
            const variacionFondo = action.payload;
            const iniC = state.datos.fondoTokensCentroIni;
            const fondoTokensCentroEnd = iniC + variacionFondo;

            const ini = state.datos.fondoTokensIni;
            const entreg = state.datos.totalEntregado;
            const recuperados = state.datos.totalTokensMaq;
            const fondoTokensEnd = ini + recuperados - entreg - variacionFondo;


            return {
                datos: {
                    ...state.datos,
                    fondoTokensCentroEnd: fondoTokensCentroEnd,
                    fondoTokensEnd: fondoTokensEnd
                },
                isLoading: false,
                semanaCerrada: false
            }

        case DESBLOQUEAR_CIERRE_SEMANAL + "_SUCCESS":

            return {
                ...state,
                isLoading: false,
                semanaCerrada: false
            }

        case CIERRE_SEMANAL_CERRAR_SEMANA + "_SUCCESS":

            return {
                ...state,
                isLoading: false,
                semanaCerrada: true
            }

        case MODIFY_MAQ_ARCADE_CIERRE_SEMANAL:

            const newArcade = state.datos.arcade.map(row => {
                if (row.zonaId === action.payload.zonaId) {
                    return {
                        ...row,
                        euros: row.euros + action.payload.total_euros,
                        eurosSinMult: row.eurosSinMult + action.payload.total_euros_sin_mult,
                        tickets: row.tickets + action.payload.total_tickets,
                        tokens: row.tokens + action.payload.total_tokens,
                        regalos: row.regalos + action.payload.total_regalos,
                        visas: row.visas + action.payload.total_visas,
                    }
                }
                else return row;
            })

            let totalEuros = 0.0;
            let totalEurosSinMult = 0.0;

            newArcade.forEach(r => {
                totalEuros += r.euros;
                totalEurosSinMult += (r.eurosSinMult ? r.eurosSinMult: 0.0);
            }); 

            const a = { ...state.datos, arcade: newArcade, totalEurosMaq: totalEuros, totalEurosMaqSinMult: totalEurosSinMult }

            return {
                ...state,
                datos: a
            }

        case UPDATE_BILLARES_CIERRE_SEMANAL + "_SUCCESS":

            if (action.payload.data.update) {

                return {
                    datos: {
                        ...state.datos,
                        totalEurosMaq: state.datos.totalEurosMaq + action.payload.data.importe,
                        arcade: action.payload.data.arcade
                    },
                    isLoading: false,
                    semanaCerrada: false
                }
            }

            return state;


        case RESET_CIERRE_SEMANAL_DATOS:

            return initialState;

        default:
            return state;
    }

}